import React, { Component } from "react";
import queryString from "query-string";

import isPage from "../hoc/isPage";
import { AppContext } from "../context/AppContext";
import logo from "../img/super-cloud-rgb.png";
//import { isEmpty } from '../helpers';


class Login extends Component {


    componentDidMount() {
        //debugger;
        let vals = queryString.parse(window.location.search);

        //check for browser language whenever user goes to logon page 
        var lang = navigator.language || navigator.userLanguage;
        this.context.setLanguage(lang.slice(0, 2))

        // check reason for the user being on this page.
        // if the user was redirected here, then we would have passed in a querystring parameter like this:
        // /?s=unableToLogin
        // based on this, show the error message, then redirect the user back to / so the querystring is no longer there.
        if (vals && vals.s) {
            switch (vals.s) {
                case "unableToLogin":
                    this.props.alert(
                        "error",
                        this.props.returnLocalizedString("m0023"),
                        this.props.returnLocalizedString("m0220")
                    );
                    break;
                case "logout":
                    //this.context.logout();
                    this.props.alert(
                        "success",
                        this.props.returnLocalizedString("m0221"),
                        this.props.returnLocalizedString("m0222")
                    );
                    break;
                case "noAccess":
                    this.props.alert(
                        "error",
                        this.props.returnLocalizedString("m0223"),
                        this.props.returnLocalizedString("m0224")
                    );
                    break;
                default:
                    break;
            }
            this.props.history.push("/");

        }
    }

    handleAuth0Login = () => {
        let defaultEmail = localStorage.getItem("somLoginEmail");

        this.context.auth.login(defaultEmail ? defaultEmail : "");
    };

    render() {

        //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
        //!DBTRANS! @m0220@ There was a problem logging you in. Please ask your system administrator to verify that your account is active. !DEVNOTE! Action status
        //!DBTRANS! @m0220@ Logged out !DEVNOTE! Action status
        //!DBTRANS! @m0220@ You have been successfully logged out of the system. !DEVNOTE! Action status
        //!DBTRANS! @m0220@ Access denied !DEVNOTE! Action status
        //!DBTRANS! @m0220@ Sorry, you don't have access to this part of the site. Log in and try again. !DEVNOTE! Action status
        //!DBTRANS! @m0220@ Suggested Order Management !DEVNOTE! Text label
        //!DBTRANS! @m0220@ Login !DEVNOTE! Button label

        return (
            <AppContext.Consumer>
                {context => (
                    <React.Fragment>

                        <section className="app-login">
                            <section className="inner">
                                <img className="logo" src={logo} alt="" />
                                <h1><acronym title={this.props.returnLocalizedString("m0225")}>{this.props.returnLocalizedString("m0226")}</acronym></h1>


                                <fieldset>
                                    <button
                                        className="button-login"
                                        onClick={this.handleAuth0Login}
                                    >
                                        {this.props.returnLocalizedString("m0227")}
                                    </button>
                                </fieldset>


                            </section>
                        </section>
                    </React.Fragment>
                )}
            </AppContext.Consumer>
        );
    }
}


export default isPage(Login);

Login.contextType = AppContext;



// WEBPACK FOOTER //
// ./src/containers/Login.js